import { infoConstants, infonewsguideConstants } from "../constants";


export function info(state = { loading: false }, action) {
    switch (action.type) {
        case infoConstants.GET_REQUEST:
            return {
                infoList: "",
                loading: true,
                done: false,
                error: undefined,
            };
        case infoConstants.GET_SUCCESS:
            // console.log(action.payload)
            return {
                infoList: action.payload,
                loading: false,
                done: true,
                error: undefined,
            };
        case infoConstants.GET_FAILURE:
            // console.log(action.payload)
            return {
                error: action.payload,
                infoList: Object.keys({ ...state.infoList }).length === 0 ? "" : { ...state.infoList },
                loading: false,
                done: true
            };
        case infoConstants.GET_FAILURE_DONE:
            return {
                error: Object.keys({ ...state.error }).length === 0 ? "" : { ...state.error },
                infoList: "",
                loading: false,
                done: false
            };
        default:
            // console.log("in default")
            // console.log(state)
            return state;
    }
}

export function infonewsguides(state = { loading: false }, action) {
    switch (action.type) {
        case infonewsguideConstants.GET_REQUEST:
            return {
                infoList: "",
                loading: true,
                done: false,
                error: undefined,
            };
        case infonewsguideConstants.GET_SUCCESS:
            // console.log(action.payload)
            return {
                infoList: action.payload,
                loading: false,
                done: true,
                error: undefined,
            };
        case infonewsguideConstants.GET_FAILURE:
            // console.log(action.payload)
            return {
                error: action.payload,
                infoList: Object.keys({ ...state.infoList }).length === 0 ? "" : { ...state.infoList },
                loading: false,
                done: true
            };
        case infonewsguideConstants.GET_FAILURE_DONE:
            return {
                error: Object.keys({ ...state.error }).length === 0 ? "" : { ...state.error },
                infoList: "",
                loading: false,
                done: false
            };
        default:
            // console.log("in default")
            // console.log(state)
            return state;
    }
}